import axios from './axios'
import bus from './bus'

import moment from 'moment'
import lodash from 'lodash'

let instaled = false

// Plugin install
const install = Vue => {
    if (instaled) return // Plugin já foi instalado

    Object.defineProperties(Vue.prototype, {
        $http: {
            get() {
                return axios
            },
        },
        $bus: {
            get() {
                return bus
            },
        },
        $moment: {
            get() {
                moment.locale('pt-br')
                return moment
            },
        },
        $lodash: {
            get() {
                return lodash
            },
        },
    })

    instaled = true
}

export default install
